module.exports = __webpack_public_path__ + "static/img/line.3aa37857.svg";